import { cn } from "@newxsystems/shared";
import type { IGroundSectionProps } from "./GroundSection.props";

export const GroundSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IGroundSectionProps) => (
  <section
    className={cn("ground-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("ground-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

GroundSection.displayName = "Content::GroundSection";
